<template>
  <div class="moderator-candidate-resumes-actions__search">
    <div class="moderator-candidate-resumes-actions__label">{{ $tModeratorCandidates('To Search') }}</div>
    <BaseSelect v-model="searchType"
                :options="options"
                :getOptionText="getOptionText"
                class="moderator-candidate-resumes-actions__search-select  _white  _shadow"/>
    <BaseInput :placeholder="$tModeratorCandidates('Search')"
               v-model="search"
               class="moderator-candidate-resumes-actions__search-input  _white"/>
  </div>
</template>

<script>
  export default {
    name: 'AMCandidatesResumesPageActionsSearch',
    props: {
      querySearchTypes: Array
    },
    data(vm) {
      return {
        options: vm.querySearchTypes
      }
    },
    computed: {
      searchType: {
        get() {
          const options = this.options
          const value = this.$route.query['search-type']

          if (!value) return options[0]

          return options.find(o => o.value === value) || options[0]
        },
        set(value) {
          const query = JSON.parse(JSON.stringify(this.$route.query))
          query['search-type'] = value.value
          delete query['page']

          this.$router.push({
            query
          }).catch(() => ({}))
        }
      },
      search: {
        get() {
          return this.$route.query.search
        },
        set(value) {
          const query = JSON.parse(JSON.stringify(this.$route.query))
          if (value) {
            query.search = value
          } else {
            delete query.search
          }

          delete query['page']

          this.$router.push({
            query
          }).catch(() => ({}))
        }
      }
    },
    methods: {
      getOptionText(option) {
        return this.$tModeratorCandidates(option.text)
      },
    }
  }
</script>

<style lang="less">

</style>
